module.exports = __webpack_public_path__ + "static/shower2-a950c7c1c522e14d7fe438f8b05f1630.jpg";